module.exports = __webpack_public_path__ + "img/raekwon_davis.8389e205.png";